import { render, staticRenderFns } from "./ModalServiceTax.vue?vue&type=template&id=46df6b50&scoped=true&"
import script from "./ModalServiceTax.vue?vue&type=script&lang=js&"
export * from "./ModalServiceTax.vue?vue&type=script&lang=js&"
import style0 from "./ModalServiceTax.vue?vue&type=style&index=0&id=46df6b50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46df6b50",
  null
  
)

export default component.exports